import styled from 'styled-components';

const AutomationTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;

const Name = styled.div`
  cursor: pointer;
  text-decoration: underline;
`;

const EmptyTableWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  margin: 120px 0;
`;

const FilterWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const SecondHeadWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-weaker);
  border-bottom: 1px solid var(--color-border-default);
  display: flex;
  flex-direction: row;
  gap: 8px;
  height: 48px;
  padding: 0 16px;
`;

export { AutomationTableWrapper, EmptyTableWrapper, FilterWrapper, Name, SecondHeadWrapper };
